import { logging } from '../../logging';

export const logger = logging.getLogger('thumbnails-loader');
